/* eslint-disable import/no-named-as-default */
import React from "react";
import { Provider } from "react-redux";
import store from "../../store";
import PortalAgencySignUp from "./PortalAgencySignUp";

const ProviderComponent = () => (
  <Provider store={store}>
    <PortalAgencySignUp />
  </Provider>
);

export default ProviderComponent;
